import React from 'react'
import { WarningOutlined } from '@material-ui/icons'

export const DeletedFileWarningIcon = () => (
  <WarningOutlined fontSize="small" color="error" />
)
